import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'percentage' } )
export class PercentagePipe implements PipeTransform {

    transform( pNumber1: number, pNumber2: number ): number {
        if (pNumber2 == 0){
            return 0;
        } else {
            return Math.floor((pNumber1 / pNumber2) * 100);
        }
    }
}